<template>
  <v-container>
    <v-row style="display: flex; flex-direction: column">
      <Header :items="items">
        {{ items }}
        <template slot="title">
          {{ $tc("newController.editRegisters") }}
        </template>
      </Header>
      <v-col>
        <div class="btn__container">
          <MoreInformation />

          <RegisterRules :date="date" />
          <v-dialog
            v-model="showDialog"
            max-width="450"
            @keydown.esc="cancelValidate()"
            @keydown.enter="handleAccept()"
            persistent
          >
            <v-card>
              <v-card-title class="px-2 py-2">
                <v-alert
                  dense
                  outlined
                  type="error"
                  class="text-left"
                  v-html="dialogMessage"
                ></v-alert>
              </v-card-title>
              <v-card-actions class="d-flex justify-space-between mt-n4">
                <v-btn class="bt-exit large" @click="cancelValidate()">{{
                  $tc("commons.cancel")
                }}</v-btn>
                <v-btn class="bt-acept large" @click="handleAccept()">{{
                  $tc("commons.accept")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!---------------------------Agregar---------------------------------------->
          <v-dialog
            v-model="showAdd"
            max-width="530px"
            @keydown.esc="cancel()"
            @keydown.enter="validate"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="container__add">
                <v-btn
                  rounded
                  class="my-auto btn-add mr-5"
                  :title="$tc('editRegistrations.add')"
                  @click="openAdd"
                  :disabled="disabledAddRegistration"
                >
                  {{ $tc("editRegistrations.add") }}
                  <v-icon small class="ml-1" color="white" dark>
                    fa-plus
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <CardDialog style="max-width: 530px">
              <template slot="title">
                {{ $tc("editRegistrations.add") }}
              </template>
              <template slot="body">
                <v-alert
                  dense
                  v-if="error"
                  color="red"
                  elevation="5"
                  outlined
                  text
                  type="error"
                  align="center"
                  class="mr-1 ml-1"
                >
                  {{ alertValidate }}</v-alert
                >
                <v-form ref="form" v-model="valid" lazy-validation class="mx-1">
                  <v-autocomplete
                    dense
                    :label="$tc('editRegistrations.concept')"
                    :items="getConcepts"
                    required
                    :rules="rules"
                    :item-text="conceptText"
                    item-value="conceptId"
                    outlined
                    style="height: 70px"
                    v-model="data.concept"
                    @change="conceptsHours"
                  />
                  <div class="mt-2 mb-5 ml-3">
                    <date :showCheck="showCheck" />
                  </div>

                  <div class="pt-4">
                    <Time v-if="showHours" />
                  </div>
                  <v-autocomplete
                    dense
                    :label="$tc('editRegistrations.csCosts')"
                    required
                    :rules="rules"
                    :items="getCosts"
                    item-text="name"
                    item-value="id"
                    outlined
                    v-model="data.cost"
                  />
                  <v-autocomplete
                    dense
                    :label="$tc('editRegistrations.audit')"
                    outlined
                    :items="getAudit"
                    :required="showAudit == true"
                    :rules="rules"
                    item-text="comment"
                    item-value="id"
                    v-model="data.audit"
                    v-show="showAudit"
                  />
                  <v-textarea
                    :label="$tc('editRegistrations.observations')"
                    color="primary"
                    rows="1"
                    outlined
                    v-model="data.observations"
                  />
                </v-form>
                <div class="d-flex justify-space-between" style="width: 100%">
                  <v-btn class="bt-exit" @click="cancel()"
                    >{{ $tc("editRegistrations.cancel") }}
                  </v-btn>
                  <v-btn class="bt-acept" @click.prevent="validate"
                    >{{ $tc("editRegistrations.acept") }}
                  </v-btn>
                </div>
              </template>
            </CardDialog>
          </v-dialog>
        </div>
        <!------------------------------------------------------------------------>

        <!---------------------------mayor---------------------------------------->
        <v-dialog v-model="dialogGreater" max-width="600px">
          <v-card>
            <v-card-text class="pt-4">
              <h3>{{ $tc("editRegistrations.dialogDateGrater") }}</h3>
            </v-card-text>
            <v-card-actions class="d-flex justify-space-between">
              <v-btn class="bt-exit" @click="cancelGrater">{{
                $tc("editRegistrations.cancel")
              }}</v-btn>
              <v-btn class="bt-acept" @click="addNewRegis">{{
                $tc("editRegistrations.acept")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-------------------------------------------------------------------------->
        <!---------------------------Eliminar---------------------------------------->
        <v-dialog
          v-model="showDelete"
          max-width="350px"
          @keydown.esc="showDelete = false"
          @keydown.enter="deleteItem"
          persistent
        >
          <CardDialog style="max-width: 350px; overflow: hidden">
            <template slot="title">
              {{ $tc("editRegistrations.deleteItem") }}
            </template>
            <template slot="body">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-autocomplete
                dense
                :label="$tc('editRegistrations.audit')"
                class="mt-4"
                outlined
                :items="getAudit"
                item-text="comment"
                item-value="id"
                v-model="itemsToDelete.audit"
                v-show="showAudit"
              />
              <div class="d-flex justify-space-between" style="width: 100%">
                <v-btn class="bt-exit" @click="showDelete = false"
                  >{{ $tc("editRegistrations.cancel") }}
                </v-btn>
                <v-btn class="bt-acept" @click.prevent="deleteItem">
                  {{ $tc("editRegistrations.delete") }}</v-btn
                >
              </div>
            </template>
          </CardDialog>
        </v-dialog>

        <!---------------------------.....---------------------------------------->
        <!---------------------------Editar---------------------------------------->
        <v-dialog
          v-model="showEdit"
          max-width="530px"
          @keydown.esc="cancel = false"
          @keydown.enter="auditEdit"
          persistent
        >
          <CardDialog max-width="530px">
            <template slot="title"
              >{{ $tc("editRegistrations.editRegis") }}
            </template>
            <template slot="body">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mx-2"
              >
                {{ alertValidate }}</v-alert
              >
              <v-form
                ref="formEdit"
                v-model="validEdit"
                lazy-validation
                class="mx-2"
              >
                <v-autocomplete
                  dense
                  :label="$tc('editRegistrations.concept')"
                  :items="getConceptsEditDay"
                  item-text="name"
                  item-value="conceptId"
                  outlined
                  style="height: 70px"
                  v-model="editItems.conceptoId"
                  @change="conceptsHours()"
                  v-if="showEditDay"
                />
                <v-autocomplete
                  dense
                  :label="$tc('editRegistrations.concept')"
                  :items="getConceptsEditHours"
                  item-text="name"
                  item-value="conceptId"
                  outlined
                  style="height: 70px"
                  v-model="editItems.conceptoId"
                  @change="conceptsHours()"
                  v-else
                />

                <div class="d-flex justify-space-around">
                  <div class="d-flex mb-5 ml-1 mr-1">
                    <span
                      v-show="salModif"
                      class="mt-1"
                      style="font-weight: bolder"
                      >*</span
                    >

                    <date :showCheck="showCheck" />

                    <span
                      v-show="entModif"
                      class="mt-1"
                      style="font-weight: bolder"
                      >*</span
                    >
                  </div>
                </div>

                <!--   <div class="mt-2 mb-5 ml-3 mr-1">
                    <date :showCheck="showCheck" />
                  </div> -->
                <div class="pt-4">
                  <Time v-if="showHours" />
                </div>

                <v-autocomplete
                  denseclass="mt-2"
                  :label="$tc('editRegistrations.csCosts')"
                  :items="getCosts"
                  item-text="name"
                  item-value="id"
                  outlined
                  v-model="editItems.csCostoId"
                  required
                  :rules="rules"
                />
                <v-autocomplete
                  dense
                  :label="$tc('editRegistrations.audit')"
                  outlined
                  :items="getAudit"
                  item-text="comment"
                  item-value="id"
                  v-model="editItems.comentId"
                  v-show="showAudit"
                />
                <v-textarea
                  :label="$tc('editRegistrations.observations')"
                  color="primary"
                  rows="1"
                  outlined
                  v-model="editItems.observaciones"
                />
              </v-form>
              <div class="d-flex justify-space-between mx-2" style="width=100%">
                <v-btn class="bt-exit" @click="cancel"
                  >{{ $tc("editRegistrations.cancel") }}
                </v-btn>
                <v-btn class="bt-acept" @click.prevent="auditEdit">
                  {{ $tc("editRegistrations.acept") }}</v-btn
                >
              </div>
            </template>
            <template slot="actions"> </template>
          </CardDialog>
        </v-dialog>
        <!------------------------------------------------------------------------->

        <DataTableDetailday
          :items="getRegistrations"
          :headers="headers"
          :openEdit="openEdit"
          :openDelete="openDelete"
          :loader="loader"
        />
      </v-col>
    </v-row>

    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import registrations from "@/store/gestionTiempos/registrations";
import moment from "moment";
import Header from "../common/Header.vue";
import CardDialog from "../common/CardDialog.vue";
import DataTableDetailday from "../common/DataTableDetailday.vue";
import RegisterRules from "../DetalleDelDia/RegisterRules.vue";
import MoreInformation from "./MoreInformation.vue";
import resultSettlementHours from "@/store/gestionTiempos/resultSettlementHours";
import Date from "../common/DateRegis.vue";
import Time from "./Time.vue";
export default {
  components: {
    Header,
    CardDialog,
    DataTableDetailday,
    RegisterRules,
    MoreInformation,
    Date,
    Time,
  },
  props: {
    items: Object,
    loading: Boolean,
  },
  data() {
    return {
      showCheck: true,
      entModif: null,
      salModif: null,
      endMenuCalendarEdit: false,
      showInfo: false,
      startCalendarMenuEdit: false,
      endMenuTimeEdit: false,
      startTimeMenuEdit: false,
      audit: localStorage.getItem("auditRegis"),
      showAudit: false,
      loader: true,
      showDelete: false,
      showEdit: false,
      dateEditStartIso: null,
      dateEditEndIso: null,
      data: {
        concept: null,
        startDay: this.$store.state.gestionTiempos.dateFromComponents,
        endDay: this.$store.state.gestionTiempos.dateToComponents,
        timeStartDay: "00:00",
        timeEndDay: "00:00",
        cost: null,
        audit: null,
        observations: "",
      },
      alertValidate: "",
      itemsToDelete: {
        audit: null,
      },
      alertError: false,
      alertOk: false,
      textAlert: "",
      isDay: false,
      originEnd: null,
      originStart: null,
      dialogGreater: false,
      showHours: null,
      showEditDay: false,
      endMenuTime: false,
      endMenuCalendar: false,
      startTimeMenu: false,
      startCalendarMenu: false,
      error: false,
      valid: true,
      validEdit: true,
      greater: this.$tc("editRegistrations.greater"),
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      showAdd: false,
      date: null,
      close: false,
      editItems: {
        comentId: null,
        observaciones: "",
      },

      headers: [
        {
          text: "Entrada",
          value: "entryWithModif",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Salida",
          value: "exitWithModif",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Concepto",
          value: "nameConcept",
          class: "primary secondary--text",
          align: "center",
        },
        {
          text: "Centro de costo",
          value: "nameCsCost",
          class: "primary secondary--text",
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          align: "center",
        },
      ],
      errorValidate: false,
      alertMessageValidate: "",
      showDialog: false,
      dialogMessage: "",
      payloadToSave: null,
    };
  },

  mounted() {
    this.loader = false;
    this.date = moment.utc(this.items.date, "DD-MM-YYYY").format("YYYY-MM-DD");
  },

  computed: {
    disabledAddRegistration() {
      let asegurables = localStorage.getItem("asegurables");
      return !asegurables.includes("accion:agregarregistracion");
    },
    getRegistrations() {
      return registrations.state.registrations;
    },
    getConcepts() {
      return registrations.state.concepts;
    },
    getConceptsEditHours() {
      let conceptsHours = registrations.state.concepts.filter((element) => {
        return element.licTot === "N";
      });

      return conceptsHours;
    },
    getConceptsEditDay() {
      let conceptsDay = registrations.state.concepts.filter((element) => {
        return element.licTot !== "N";
      });

      this.isDay = true;

      return conceptsDay;
    },
    getCosts() {
      return registrations.state.csCosts;
    },
    getAudit() {
      return registrations.state.audit;
    },
  },
  methods: {
    handleAccept() {
      if (this.showAdd) {
        this.confirmForm(this.payloadToSave);
      } else {
        this.confirmEdit(this.payloadToSave);
      }
      this.cancelValidate();
    },
    cancelValidate() {
      this.alertMessageValidate = "";
      this.showDialog = false;
      this.dialogMessage = "";
      this.payloadToSave = null;
    },
    async openAdd() {
      this.showHours = true;
      await registrations.dispatch("getAudit");
      await registrations.dispatch("getCsCostGuidelines");
      await registrations.dispatch("getConcepts");
      this.auditTrue();
      this.data = {
        concept: null,
        startDay: this.$store.state.gestionTiempos.dateFromComponents,
        endDay: this.$store.state.gestionTiempos.dateToComponents,
        timeStartDay: this.$store.state.gestionTiempos.timeFrom,
        timeEndDay: this.$store.state.gestionTiempos.timeTo,
        observations: "",
      };
      this.itemsDefaults();
      this.showAdd = true;
    },
    formatDate(date) {
      return moment.utc(date).format("YYYY-MM-DD HH:mm:ss");
    },
    validate() {
      const entry = this.$store.state.gestionTiempos.dateFromComponents;
      const end = this.$store.state.gestionTiempos.dateToComponents;
      let entryHours =
        "T" + this.$store.state.gestionTiempos.timeFrom + ":00" + ".000Z";
      this.originStart = entry + entryHours;
      let endHours =
        "T" + this.$store.state.gestionTiempos.timeTo + ":00" + ".000Z";
      this.originEnd = end + endHours;
      let originStart = this.formatDate(this.originStart);
      let originEnd = this.formatDate(this.originEnd);
      let inicio = moment(originStart);
      let fin = moment(originEnd);
      let difference = fin.diff(inicio, "hours");
      let itemEntryOrigin = moment
        .utc(this.items.startDay)
        .format("YYYY-MM-DD");
      let itemEndOrigin = moment.utc(this.items.endDay).format("YYYY-MM-DD");
      this.dialogGreater = false;
      let seconsIn = originStart.slice(14, 16);
      let secondEnd = originEnd.slice(14, 16);

      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.isDay) {
          if (entry > end) {
            this.error = true;
            this.alertValidate = this.$tc("editRegistrations.less");
            setTimeout(() => {
              this.error = false;
            }, 2500);
          } else {
            if (itemEndOrigin < end || itemEntryOrigin < entry) {
              this.dialogGreater = true;
            } else {
              this.addNewRegis();
            }
          }
        } else {
          if (difference <= 24 && difference >= 0) {
            if (entry > end) {
              this.error = true;
              this.alertValidate = this.$tc("editRegistrations.less");
              setTimeout(() => {
                this.error = false;
              }, 2500);
            } else if (difference == 0 && seconsIn == secondEnd) {
              this.error = true;
              this.alertValidate =
                "La hora de entrada no puede ser igual a la de salida";
              setTimeout(() => {
                this.error = false;
              }, 2500);
            } else if (itemEndOrigin < end || itemEntryOrigin < entry) {
              this.dialogGreater = true;
            } else {
              this.addNewRegis();
            }
          } else {
            this.error = true;
            this.alertValidate =
              difference < 0
                ? this.$tc("editRegistrations.less")
                : this.$tc("editRegistrations.greater");
            setTimeout(() => {
              this.error = false;
            }, 2500);
          }
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    async addNewRegis() {
      this.dialogGreater = false;
      let cost = registrations.state.csCosts.filter((item) => {
        return item.id == this.data.cost;
      })[0];
      let concepts = registrations.state.concepts.filter((item) => {
        return item.conceptId == this.data.concept;
      })[0];
      let endDay;

      if (this.isDay) {
        endDay = moment(this.originEnd)
          .utc()
          .add(1, "d")
          .format("YYYY-MM-DD HH:mm:ss");
        endDay = moment.utc(endDay).format("YYYY-MM-DD[T]HH:mm:ss") + ".000Z";
      } else {
        endDay = this.originEnd;
      }
      let payload = {
        empId: parseInt(localStorage.getItem("empId"), 10),
        fecha: this.items.dateNotFormat,
        entrada: this.originStart,
        salida: this.originEnd,
        observaciones: this.data.observations,
        csCostoId: this.data.cost,
        conceptoId: this.data.concept,
        comentId: this.data.audit,
        costName: cost.name.trim(),
        conceptName: concepts.name.trim(),
        originExit: endDay,
      };
      const isValid = await this.validarSaldos(payload, concepts.licTot);
      if (isValid) {
        // Si es válido, llamamos a confirmForm
        this.confirmForm(payload);
      } else if (this.alertMessageValidate) {
        // Si hay un mensaje de advertencia, muestra el diálogo de confirmación
        this.showDialog = true;
        this.dialogMessage = this.alertMessageValidate;
        this.payloadToSave = payload;
      } else {
        // Si no hay datos en currentAccount, guarda directamente sin validación adicional
        this.confirmForm(payload);
      }
    },

    async validarSaldos(payload, conceptLicTot, saldoEdit = 0) {
      try {
        await registrations.dispatch("getCurrentAccount", payload);
        const currentAccounts = registrations.state.currentAccount;
        if (!currentAccounts || !currentAccounts.length) {
          this.errorValidate = false;
          this.alertMessageValidate = "";
          return false;
        }
        let alertMessages = [];
        let isValid = true;

        for (const currentAccount of currentAccounts) {
          const startDate = moment(payload.entrada || payload.fechaEntrada);
          const endDate = moment(payload.originExit || payload.fechaSalida);

          const matchedConcept = currentAccount.conceptos.find(
            (concepto) =>
              concepto.conceptoId === payload.conceptoId &&
              concepto.csCostoId === payload.csCostoId,
          );

          if (!matchedConcept) {
            continue; // Pasar a la siguiente cuenta
          }

          const { paramA = 0, paramB = 0 } = matchedConcept;
          let duration, saldoCalculado;

          if (conceptLicTot === "S") {
            duration = endDate.diff(startDate, "days");
            saldoCalculado = paramA + paramB * duration;
          } else {
            const hours = endDate.diff(startDate, "hours");
            saldoCalculado = paramA + paramB * hours;
          }

          let saldoFinal =
            matchedConcept.debCred === "C"
              ? currentAccount.saldo - saldoEdit + saldoCalculado
              : currentAccount.saldo + saldoEdit - saldoCalculado;

          if (
            matchedConcept.debCred === "C" &&
            saldoFinal > currentAccount.topeMax
          ) {
            isValid = false;
            alertMessages.push(
              `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y excede el límite máximo permitido de ${currentAccount.topeMax}.`,
            );
          } else if (
            matchedConcept.debCred === "D" &&
            saldoFinal < currentAccount.topeMin
          ) {
            isValid = false;
            alertMessages.push(
              `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y está por debajo del límite mínimo permitido de ${currentAccount.topeMin}.`,
            );
          }
        }

        if (!isValid) {
          this.errorValidate = true;
          this.alertMessageValidate = alertMessages
            .join(" ")
            .replace(/\. • /gu, ".<br>• ");
        } else {
          this.errorValidate = false;
          this.alertMessageValidate = "";
        }
        return isValid;
      } catch (error) {
        console.error("Error en la validación de saldos:", error);
        this.errorValidate = true;
        this.alertMessageValidate = "Error al obtener las cuentas actuales.";
        return false;
      }
    },

    confirmForm(payload) {
      registrations.commit("setNewRegis", payload);
      registrations
        .dispatch("getNewRegis")
        .then((r) => {
          registrations.dispatch("getRegistrations");
          resultSettlementHours.dispatch("getResults").then(() => {
            this.$store.dispatch("changeSchedule/getScheduleElement");
          });
          this.textAlert = this.$tc("alert.ok");
          this.alertOk = true;
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = e.response.data.error.message;
        });
      this.$refs.form.resetValidation();
      this.cancel();
    },
    async openEdit(item) {
      this.entModif = item.entModif;
      this.salModif = item.salModif;
      this.auditTrue();
      let audit;
      await registrations.dispatch("getAudit").then(() => {
        audit = registrations.state.audit;
      });
      await registrations.dispatch("getConcepts").then(() => {});
      await registrations.dispatch("getCsCostGuidelines").then(() => {
        this.showEdit = true;
      });

      let conceptId = registrations.state.concepts.find((option) => {
        return option.conceptId == item.conceptId;
      });
      if (conceptId.licTot == "S") {
        this.isDay = true;
        this.showHours = false;
        this.showEditDay = true;
      } else {
        this.isDay = false;
        this.showHours = true;
        this.showEditDay = false;
      }
      this.$forceUpdate();
      let csCostId = registrations.state.csCosts.filter((option) => {
        return option.id == item.csCostId;
      });

      let entrada = this.formatDateEdit(item.entry, "date");
      let hoursEntry = this.formatDateEdit(item.entry, "time");
      let salida = this.formatDateEdit(item.exit, "date");
      let hoursExit = this.formatDateEdit(item.exit, "time");
      this.$store.commit("gestionTiempos/setTimeFrom", hoursEntry);
      this.$store.commit("gestionTiempos/setTimeTo", hoursExit);
      this.$store.commit("gestionTiempos/setDateFromComponents", entrada);
      this.$store.commit("gestionTiempos/setDateToComponents", salida);

      if (entrada == salida && hoursEntry == hoursExit) {
        hoursEntry = "00:00";
      }
      if (item.exit == "Invalid date Invalid date") {
        salida = null;
        hoursExit = "00:00";
      }
      const entradaDate = moment.utc(item.entry, "DD-MM-YYYY HH:mm");
      const salidaDate = moment.utc(item.exit, "DD-MM-YYYY HH:mm");

      if (conceptId.licTot === "S") {
        // Diferencia en días
        this.saldoEdit = Math.abs(salidaDate.diff(entradaDate, "days")) + 1;
      } else {
        // Diferencia en horas
        this.saldoEdit = Math.abs(entradaDate.diff(salidaDate, "hours"));
      }
      this.saldoEdit = this.saldoEdit === NaN ? 0 : this.saldoEdit;
      this.editItems = {
        conceptoId: item.conceptId,
        fecha: this.date,
        fechaEntrada: entrada,
        horaEntrada: hoursEntry,
        fechaSalida: salida,
        horaSalida: hoursExit,
        csCostoId: csCostId[0].id,
        observaciones: item.observations === null ? "" : item.observations,
        empId: item.empId,
        salidaOriginal: item.originExit,
        entradaOriginal: item.originEntry,
        entModif: true,
        comentId: audit[0].id,
        liqTotal: item.liqTotal,
      };
    },
    formatDateEdit(item, date) {
      let part = item.split(" ");
      if (date == "date") {
        return moment(part[0], "DD-MM-YYYY").format("YYYY-MM-DD");
      } else {
        return part[1];
      }
    },
    auditEdit() {
      if (this.showAudit == true) {
        if (this.editItems.comentId == undefined) {
          this.error = true;
          this.alertValidate = this.$tc("editRegistrations.required");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.validateEdit();
        }
      } else {
        this.validateEdit();
      }
    },
    // Validaciones de edit valida más que nada los horarios que sean validos
    validateEdit() {
      this.dateEditStartIso =
        this.$store.state.gestionTiempos.dateFromComponents +
        "T" +
        this.$store.state.gestionTiempos.timeFrom +
        ":00.000Z";
      const dateComponent =
        this.$store.state.gestionTiempos.dateToComponents ||
        moment.utc().format("YYYY-MM-DD"); // Fecha actual si no está definida
      const timeComponent = this.$store.state.gestionTiempos.timeTo || "00:00";

      this.dateEditEndIso = `${dateComponent}T${timeComponent}:00.000Z`;

      let dateStartFormat = moment
        .utc(this.dateEditStartIso)
        .format("YYYY-MM-DD HH:mm:ss");
      let dateEndFormat = moment
        .utc(this.dateEditEndIso)
        .format("YYYY-MM-DD HH:mm:ss");
      let start = moment(dateStartFormat);
      let end = moment(dateEndFormat);
      let itemEntryOrigin = moment
        .utc(this.dateEditStartIso)
        .format("YYYY-MM-DD");
      let itemEndOrigin = moment.utc(this.dateEditEndIso).format("YYYY-MM-DD");
      let difference = end.diff(start, "hours");

      let seconsIn = dateStartFormat.slice(14, 16);
      let secondEnd = dateEndFormat.slice(14, 16);
      let endDay;
      let valid = this.$refs.formEdit.validate();

      if (valid) {
        if (this.isDay) {
          if (dateStartFormat > dateEndFormat) {
            this.error = true;
            this.alertValidate = this.$tc("editRegistrations.less");
            setTimeout(() => {
              this.error = false;
            }, 2500);
          } else {
            this.dateEditStartIso =
              moment.utc(this.dateEditStartIso).format("YYYY-MM-DD") +
              "T00:00:00.000Z";
            endDay = moment(this.dateEditEndIso)
              .utc()
              .add(1, "d")
              .format("YYYY-MM-DD HH:mm:ss");
            this.dateEditEndIso =
              moment.utc(endDay).format("YYYY-MM-DD") + "T00:00:00.000Z";
            this.editRegis();
          }
        } else {
          // Si liqTotal es true, no se validan las horas
          if (this.editItems.liqTotal) {
            this.editRegis();
            return;
          }

          if (difference <= 24 && difference >= 0) {
            if (dateStartFormat > dateEndFormat) {
              this.error = true;
              this.alertValidate = this.$tc("editRegistrations.less");
              setTimeout(() => {
                this.error = false;
              }, 2500);
            } else if (difference == 0 && seconsIn == secondEnd) {
              this.error = true;
              this.alertValidate =
                "La hora de entrada no puede ser igual a la de salida";
              setTimeout(() => {
                this.error = false;
              }, 2500);
            } else if (itemEndOrigin < end || itemEntryOrigin < start) {
              this.dialogGreater = true;
            } else {
              this.editRegis();
            }
          } else {
            this.error = true;
            this.alertValidate =
              difference < 0
                ? this.$tc("editRegistrations.less")
                : this.$tc("editRegistrations.greater");
            setTimeout(() => {
              this.error = false;
            }, 2500);
          }
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    async editRegis() {
      let conceptId = registrations.state.concepts.find((option) => {
        return option.conceptId == this.editItems.conceptoId;
      });
      let csCostId = registrations.state.csCosts.find((option) => {
        return option.id == this.editItems.csCostoId;
      });
      let payload = {
        conceptoId: this.editItems.conceptoId,
        fecha: moment.utc(this.items.date, "DD/MM/YYYY").format("YYYY-MM-DD"),
        fechaEntrada: this.dateEditStartIso,
        fechaSalida: this.dateEditEndIso,
        csCostoId: this.editItems.csCostoId,
        observaciones: this.editItems.observaciones,
        comentId: this.editItems.comentId,
        empId: this.editItems.empId,
        nombreConcepto: conceptId.name.trim(),
        nombreCsCosto: csCostId.name.trim(),
        salidaOriginal: this.editItems.salidaOriginal,
        entradaOriginal: this.editItems.entradaOriginal,
      };
      const isValid = await this.validarSaldos(
        payload,
        conceptId.licTot,
        this.saldoEdit,
      );
      if (isValid) {
        this.confirmEdit(payload);
      } else if (this.alertMessageValidate) {
        this.showDialog = true;
        this.dialogMessage = this.alertMessageValidate;
        this.payloadToSave = payload;
      } else {
        this.confirmEdit(payload);
      }
    },
    confirmEdit(payload) {
      registrations.commit("setEdit", payload);
      registrations
        .dispatch("edit")
        .then((r) => {
          registrations.dispatch("getRegistrations");
          resultSettlementHours.dispatch("getResults").then(() => {
            this.$store.dispatch("changeSchedule/getScheduleElement");
          });
          this.textAlert = this.$tc("alert.okEdit");
          this.alertOk = true;
        })
        .catch((e) => {
          this.textAlert = e.response.data.error.message;
          this.alertError = true;
        });
      this.cancel();
    },
    // se abre el modal de delete, y se crea el objeto a enviar
    openDelete(item) {
      let audit;

      registrations.dispatch("getAudit").then(() => {
        this.showDelete = true;
        audit = registrations.state.audit;
        this.itemsToDelete = {
          empId: item.empId,
          entrada: item.originEntry,
          fecha: this.date,
          audit: audit[0].id,
        };
      });
      this.auditTrue();
    },
    //Funcion que hace el dispatch del delete
    deleteItem() {
      if (this.showAudit == true) {
        if (!this.itemsToDelete.audit) {
          this.error = true;
          this.alertValidate = this.$tc("editRegistrations.required");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.dispatchDelete();
        }
      } else {
        this.dispatchDelete();
      }
    },
    // Dispatch delete
    dispatchDelete() {
      let payload = {
        empId: this.itemsToDelete.empId,
        entrada: this.itemsToDelete.entrada,
        fecha: this.items.date,
        audit: this.itemsToDelete.audit,
      };
      registrations.commit("setDeleteItem", payload);
      registrations
        .dispatch("deleteRegis")
        .then((r) => {
          resultSettlementHours.dispatch("getResults");
          this.$store.dispatch("changeSchedule/getScheduleElement");
          this.textAlert = "Se eliminó correctamente";
          this.alertOk = true;
        })
        .catch(() => {
          this.textAlert = this.$tc("alert.errorDelete");
          this.alertError = true;
        });
      this.showDelete = false;
    },
    // funcion que se fija si los conceptos son dia u hora
    conceptText(item) {
      if (!item) return "";

      return item.licTot === "N"
        ? `${item.name} (Horas)`
        : `${item.name} (Días)`;
    },

    conceptsHours() {
      let concepts = registrations.state.concepts.find(
        (item) =>
          item.conceptId == this.data.concept ||
          item.conceptId == this.editItems.conceptoId,
      );

      if (!concepts) return;

      if (concepts.licTot === "N") {
        this.showHours = true;
        this.isDay = false;
      } else {
        this.showHours = false;
        this.isDay = true;
      }
    },
    // funcion que se fija si se muestra el input de auditoria
    auditTrue() {
      if (this.audit === "true") {
        this.showAudit = true;
      }
    },
    //Funcion que pone en default 2 items para el add
    itemsDefaults() {
      let audit = registrations.state.audit.find((e) => e.id == 1);
      let cost = registrations.state.csCosts.find((e) => e.id == 1);
      this.data.cost = cost.id;
      this.data.audit = audit.id;
    },
    // funcion del boton cancelar, resetea el formulario
    cancel() {
      //this.seteoDateTime();
      this.showAdd = false;
      this.showEdit = false;
      this.error = false;
      this.$store.state.gestionTiempos.timeFrom = "00:00";
      this.$store.state.gestionTiempos.timeTo = "00:00";
      this.data = {
        concept: null,
        startDay: this.$store.state.gestionTiempos.dateFromComponents,
        endDay: this.$store.state.gestionTiempos.dateToComponents,
        timeStartDay: this.$store.state.gestionTiempos.timeFrom,
        timeEndDay: this.$store.state.gestionTiempos.timeTo,
        cost: null,
        audit: null,
        observations: "",
      };
    },

    seteoDateTime() {
      const time = moment("00:00", "HH:mm").format("HH:mm");
      this.$store.commit("gestionTiempos/setDateFromComponents", this.date);
      this.$store.commit("gestionTiempos/setDateToComponents", this.date);
      this.$store.commit("gestionTiempos/setTimeFrom", time);
      this.$store.commit("gestionTiempos/setTimeTo", time);
    },

    cancelGrater() {
      this.dialogGreater = false;
    },
  },
};
</script>

<style scoped>
#data-table {
  padding: 0px !important;
  width: 100% !important;
  overflow-y: scroll !important;
  max-height: 415 !important;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.colBtn {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.btn-add {
  background-color: #39537a !important;
  color: white !important;
  margin-left: 50px !important;
}

.btn__info {
  background-color: #39537a !important;
  border-radius: 50px;
  min-width: 39px !important;
  padding: 0px !important;
  margin-left: 15px;
  height: 35px !important;
}

.btn__info:hover {
  background-color: #82a1d0 !important;
}

.btn__container {
  display: flex;
  justify-content: flex-end !important;
  align-items: flex-end;
}

.container__add {
  display: flex;
  justify-content: flex-end;
}

@media (min-width: 300px) and (max-width: 850px) {
  .container__add {
    max-width: 150px !important;
  }
}
</style>
